import { createApiInstance } from './axios-config';
import {
  DecisionAnalysis,
  AnalyzeThesisRequest,
  DetectRelationshipsRequest,
  RelationshipDetectionResult,
} from '../../types/decision.types';

/**
 * Decision API Service
 *
 * Provides methods for Decision Mode thesis analysis and
 * relationship detection between knowledge graph nodes.
 */
class DecisionApiService {
  private readonly baseUrl = '/api/v1/decision';
  private readonly axios = createApiInstance();

  /**
   * Analyze a thesis against the knowledge graph.
   * Returns categorized evidence (supporting, contradicting, neutral),
   * knowledge gaps, and confidence scoring.
   */
  async analyzeThesis(
    thesis: string,
    filters?: AnalyzeThesisRequest['filters']
  ): Promise<DecisionAnalysis> {
    const response = await this.axios.post(`${this.baseUrl}/analyze`, {
      thesis,
      filters,
    });
    return response.data.data;
  }

  /**
   * Detect relationships between specified nodes.
   * Performs pairwise comparison to find supports, contradicts, causes, depends_on.
   */
  async detectRelationships(
    nodeUids: string[],
    scope?: 'personal' | 'organization'
  ): Promise<RelationshipDetectionResult> {
    const response = await this.axios.post(`${this.baseUrl}/detect`, {
      nodeUids,
      scope,
    } as DetectRelationshipsRequest);
    return response.data.data;
  }
}

export const decisionApi = new DecisionApiService();
export default DecisionApiService;
